module.exports = __webpack_public_path__ + "img/slide_bg_04.26742576.png";